import React from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { Menu, Bell, ChevronDown } from 'lucide-react'

interface HeaderProps {
  onMenuClick: () => void
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  const { user } = useAuth()

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 print:hidden">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-6">
        <div className="flex justify-between items-center h-10">
          {/* Mobile menu button */}
          <div className="flex items-center">
            <button
              onClick={onMenuClick}
              className="lg:hidden p-1.5 rounded-md text-gray-500 hover:text-gray-900 hover:bg-gray-100"
            >
              <Menu className="h-5 w-5" />
            </button>
          </div>

          {/* Right section */}
          <div className="flex items-center space-x-2">
            {/* Notifications */}
            <button className="p-1.5 text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded-full relative">
              <Bell className="h-5 w-5" />
              <span className="absolute top-0.5 right-0.5 h-2 w-2 bg-red-500 rounded-full"></span>
            </button>

            {/* Profile dropdown */}
            <div className="relative">
              <button className="flex items-center text-xs rounded-full text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary-500">
                <div className="h-7 w-7 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-xs font-medium text-primary-600">
                    {user?.firstName?.charAt(0) || user?.email?.charAt(0) || 'A'}
                  </span>
                </div>
                <span className="hidden sm:block ml-2 text-xs font-medium text-gray-700">
                  {user?.firstName ? `${user.firstName} ${user.lastName}` : user?.email}
                </span>
                <ChevronDown className="hidden sm:block ml-1 h-4 w-4 text-gray-400" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
